import { api } from "@/lib/api";

const SUB_KEY = "qhh.push.endpoint";

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

function keyBytes(b64) {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("unsupported");
  const perm = Notification.permission === "granted" ? "granted" : await Notification.requestPermission();
  if (perm !== "granted") throw new Error("denied");
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-public-key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: keyBytes(data.key) });
  const j = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: j.endpoint, keys: j.keys });
  localStorage.setItem(SUB_KEY, j.endpoint);
  return j.endpoint;
}

export async function disablePush() {
  const saved = localStorage.getItem(SUB_KEY);
  localStorage.removeItem(SUB_KEY);
  try {
    const reg = await navigator.serviceWorker?.getRegistration();
    const sub = await reg?.pushManager?.getSubscription();
    const endpoint = sub?.endpoint || saved;
    if (endpoint) await api.post("/push/unsubscribe", { endpoint }).catch(() => {});
    if (sub) await sub.unsubscribe();
  } catch (_) { /* nothing registered */ }
}

export async function pushIsOn() {
  const endpoint = localStorage.getItem(SUB_KEY);
  if (!endpoint || !pushSupported() || Notification.permission !== "granted") return false;
  try { return (await api.get("/push/status", { params: { endpoint } })).data.subscribed; } catch (_) { return false; }
}
